var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4447 7.60396L13.2937 6.85536L10.9912 2.18729C10.9283 2.05948 10.8248 1.95602 10.697 1.89313C10.3765 1.73489 9.98694 1.86675 9.82668 2.18729L7.52408 6.85536L2.37318 7.60396C2.23117 7.62424 2.10133 7.69119 2.00192 7.79263C1.88175 7.91615 1.81552 8.08233 1.81781 8.25465C1.82009 8.42697 1.89069 8.59134 2.0141 8.71163L5.74084 12.3451L4.86038 17.4757C4.83974 17.595 4.85294 17.7178 4.89851 17.83C4.94407 17.9422 5.02017 18.0394 5.11817 18.1106C5.21617 18.1818 5.33215 18.2241 5.45297 18.2327C5.57379 18.2413 5.6946 18.2159 5.80171 18.1594L10.4089 15.7371L15.0161 18.1594C15.1419 18.2263 15.288 18.2486 15.428 18.2243C15.781 18.1634 16.0183 17.8287 15.9575 17.4757L15.077 12.3451L18.8037 8.71163C18.9052 8.61223 18.9721 8.48239 18.9924 8.34038C19.0472 7.98536 18.7997 7.6567 18.4447 7.60396Z",
    stroke: "url(#paint0_linear_885_7921)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_885_7921",
    x1: 5.39738,
    y1: 14.816,
    x2: 17.111,
    y2: 4.71441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8764FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.77f7cfab925853bb4cc927378e4e95b4.svg";
export { ForwardRef as ReactComponent };